import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

interface VitalSignsFormHeaderProps {
    title: string;
}

export const VitalSignsFormHeader = ({ title }: VitalSignsFormHeaderProps) => (
    <Grid
        xs={12}
        sx={{
            backgroundColor: "#F4F7FE",
            borderBottom: "1px solid #E0E0E0",
        }}
    >
        <ByzMuiTypography isTitle>
            {title}
        </ByzMuiTypography>
    </Grid>
);
